import { CHAT_STREAM } from '@/config/api/endpoints'
import { getApiBaseUrl, isApiConfigured } from '@/config/api/env.js'

const env = import.meta.env ?? {}

function normalizePath(path) {
  const value = String(path ?? '').trim()
  if (!value) return ''
  return value.startsWith('/') ? value : `/${value}`
}

export function isPhase1ChatStreamConfigured() {
  return (
    isApiConfigured() ||
    env.VITE_CHAT_STREAM_ENABLED === 'true' ||
    Boolean(String(env.VITE_CHAT_STREAM_URL ?? '').trim()) ||
    Boolean(String(env.VITE_CHAT_STREAM_PATH ?? '').trim())
  )
}

function defaultStreamPath(baseUrl) {
  return baseUrl.endsWith('/v1') ? '/chat/stream' : CHAT_STREAM
}

export function chatStreamUrl() {
  const explicitUrl = String(env.VITE_CHAT_STREAM_URL ?? '').trim()
  if (explicitUrl) return explicitUrl

  const baseUrl = getApiBaseUrl()
  const path = normalizePath(env.VITE_CHAT_STREAM_PATH) || defaultStreamPath(baseUrl)
  return baseUrl ? `${baseUrl}${path}` : path
}
